import { IVisitsCategoryRepository } from './VisitCategoryRepository.types';
import { IVisitCategories, IVisitCategoriesListItem, VisitCategoriesResponseType } from '@/entity/visits/visitCategories.types';
import VisitCategories from '@/entity/visits/visitCategories';
import { VisitsCategoriesSettingsRequestType } from "@/form/Settings/categories/visits.types";

import Api from '@/repository/api';
import qs from 'qs';
import { PaginationRequestType } from '@/entity/common/pagination.types';
import { ResponseDataType } from '@/form/form.types';


export class VisitsCategoryRepository implements IVisitsCategoryRepository {
    async fetchAll(data?: FormData): Promise<IVisitCategories> {
        const response = await Api.get(`/visits/category/get`, {
            params: data,
            paramsSerializer: function paramsSerializer(params) {
                return new URLSearchParams(params).toString();
            }
        });
        
        const responseData = response.data as VisitCategoriesResponseType;
        return new VisitCategories(responseData);
    }
    async fetchData(data: PaginationRequestType): Promise<IVisitCategoriesListItem> {
        console.log('Visits query - ')
        const response = await Api.get(`/visits/category/get`, {
            params: data,
            paramsSerializer: function paramsSerializer(params) {
                console.log('Visits params - '+ params)
                return qs.stringify(params, { arrayFormat: 'repeat' });
            }
        });
        const responseData = response.data as VisitCategoriesResponseType;

        return new VisitCategories(responseData).data[0];
    }
    async create(data: VisitsCategoriesSettingsRequestType): Promise<ResponseDataType> {
        const response = await Api.post(`/visits/category/create`, data);
        const responseData = response.data;
        return responseData;
    }
    async update(data: VisitsCategoriesSettingsRequestType): Promise<ResponseDataType> {
        const response = await Api.post(`/visits/category/update`, data);
        const responseData = response.data;
        return responseData;
    }
    async delete(data: { id: number }): Promise<ResponseDataType> {
        const response = await Api.post(`/visits/category/delete`, data);
        const responseData = response.data;
        return responseData;
    }
}
